<div class="salesAgent">
  <div class="salesAgent__agent">
    <div class="agent__img">
      <img
        *ngIf="dataAgent"
        [src]="dataAgent.image ? dataAgent.image : agent"
        alt="agent"
      />
    </div>
    <div class="agent__name">
      <p *ngIf="dataAgent">{{ dataAgent.firstName }}</p>
    </div>
  </div>
  <div class="salesAgent__text">
    <p>
      Ich bin persönlich für Sie da. Gemeinsam finden wir Ihren Wunschkredit.
    </p>
  </div>
  <div class="salesAgent__stars">&#9733; &#9733; &#9733; &#9733; &#9733;</div>
  <div class="salesAgent__contact" *ngIf="dataAgent">
    <a href="tel:{{ dataAgent.phoneNumber }}" class="contact__phone">
      <svg
        id="Ebene_1"
        data-name="Ebene 1"
        xmlns="http://www.w3.org/2000/svg"
        width="76.3"
        height="102.05"
        viewBox="0 0 76.3 102.05"
      >
        <defs>
          <style>
            .cls-1 {
              fill: #0563c1;
            }
          </style>
        </defs>
        <path
          class="cls-1"
          d="M17.34,100.86A13.08,13.08,0,0,1,8.64,99C2,94.66.34,89.36.84,88a67.09,67.09,0,0,1,5.9-10.8,72.85,72.85,0,0,1,7.1-9.1c2-2.3,10.5,4.9,14.4,1.9,2.7-2.1,8.7-10.9,12.9-16.9,4.1-7,9.5-15.5,10.3-18.8,1.2-4.8-8.8-9.8-7.5-12.5a75.6,75.6,0,0,1,5.4-10.2,81.44,81.44,0,0,1,7.5-9.8c1.1-1,6.6-1.6,13.2,2.7,3,1.9,6.1,6.5,5.4,9.7-2.5,11.3-10.5,28.9-22,47-10.3,15-21.5,28.8-30.4,36.4Z"
        /></svg
      >{{ dataAgent.phoneNumber }}</a
    >
    <p class="contact__text">Ich bin persönlich für Sie da</p>
  </div>
  <p class="salesAgent__title">
    <span>CHECK24</span> <br />
    <span *ngIf="dataAgent && dataAgent.gender === 'FEMALE'"
      >Kreditberaterin</span
    >
    <span *ngIf="dataAgent && dataAgent.gender === 'MALE'">Kreditberater</span>
  </p>
  <p class="salesAgent__position">
    <span *ngIf="dataAgent && dataAgent.gender === 'FEMALE'">Expertin</span>
    <span *ngIf="dataAgent && dataAgent.gender === 'MALE'">Experte</span> <br />
    <span>für den Kreditvergleich</span>
  </p>
  <button
    class="salesAgent__showMore"
    (click)="showMore = !showMore"
    (keydown)="onToggleKeydown($event)"
    [attr.aria-expanded]="showMore"
    [attr.aria-controls]="'sales-agent-details'"
    aria-label="Weitere Details zur persönlichen Beratung anzeigen oder ausblenden"
    type="button"
  >
    <span aria-hidden="true">{{ showMore ? "weniger" : "mehr" }}</span>
    <svg-icon
      src="/resultpage/assets/icons/Chevron_Arrow.svg"
      [ngClass]="['icon', showMore ? 'expanded' : '']"
      aria-hidden="true"
    ></svg-icon>
  </button>
  <div
    class="salesAgent__moreDetails"
    *ngIf="showMore"
    [attr.id]="'sales-agent-details'"
    role="region"
    aria-labelledby="sales-agent-details-title"
  >
    <p class="title" id="sales-agent-details-title">
      Persönliche Beratung bei CHECK24
    </p>
    <p>
      Günstiger, einfacher und schneller als bei uns können Sie Ihren
      Wunschkredit nirgendwo sonst abschließen. Aber auch wenn Sie Hilfe
      brauchen, oder spezielle Fragen haben, helfen wir Ihnen gerne jederzeit
      und individuell weiter.
    </p>
    <ul class="list">
      <li>
        <svg-icon
          src="/resultpage/assets/img/agent/call.svg"
          class="icon"
        ></svg-icon>
        <p>
          <strong>Kompetente Beratung von Experten</strong><br />
          Wir sind ausgebildete Kreditexperten und verfügen über jahrelange
          Erfahrung im Bereich Kreditvermittlung.
        </p>
      </li>
      <li>
        <svg-icon
          src="/resultpage/assets/img/agent/q&a.svg"
          class="icon"
        ></svg-icon>
        <p>
          <strong>Kostenlos und individuell</strong><br />
          Selbstverständlich ist die Beratung durch unseren Kreditexperten
          unverbindlich und kostenfrei - ohne Wenn und Aber!
        </p>
      </li>
      <li>
        <svg-icon
          src="/resultpage/assets/img/agent/clock.svg"
          class="icon"
        ></svg-icon>
        <p>
          <strong>Täglich 9 Stunden Zeit für Ihre persönlichen Anliegen</strong
          ><br />
          Wir sind Montag bis Sonntag von 9:00 bis 18:00 telefonisch für Sie
          erreichbar. Sie entscheiden, wann Sie Beratung benötigen und wie viel.
          Ohne lästige Terminfindung und gemütlich von zuhause aus.
        </p>
      </li>
    </ul>
  </div>
</div>
